// @generated by protoc-gen-es v2.2.5 with parameter "target=ts"
// @generated from file wavin/sentio/v1/broker_measurement.proto (package wavin.sentio.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv1";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file wavin/sentio/v1/broker_measurement.proto.
 */
export const file_wavin_sentio_v1_broker_measurement: GenFile = /*@__PURE__*/
  fileDesc("Cih3YXZpbi9zZW50aW8vdjEvYnJva2VyX21lYXN1cmVtZW50LnByb3RvEg93YXZpbi5zZW50aW8udjEipwEKEUJyb2tlck1lYXN1cmVtZW50Ei0KCXRpbWVzdGFtcBgBIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASCwoDb2lkGAIgASgNEgsKA3ZpZBgDIAEoDRINCgV2YWxpZBgEIAEoCBIRCgdudW1lcmljGAUgASgBSAASDgoEdGV4dBgGIAEoCUgAEg4KBGRhdGEYByABKAxIAEIHCgV2YWx1ZUKzAQoTY29tLndhdmluLnNlbnRpby52MUIWQnJva2VyTWVhc3VyZW1lbnRQcm90b1ABWiZ3YXZpbi5pby9nZW4vZ28vd2F2aW4vc2VudGlvL3YxO3NlbnRpb6ICA1dTWKoCD1dhdmluLlNlbnRpby5WMcoCD1dhdmluXFNlbnRpb1xWMeICG1dhdmluXFNlbnRpb1xWMVxHUEJNZXRhZGF0YeoCEVdhdmluOjpTZW50aW86OlYxYgZwcm90bzM", [file_google_protobuf_timestamp]);

/**
 * BrokerMeasurement represents a single broker value measurement
 *
 * @generated from message wavin.sentio.v1.BrokerMeasurement
 */
export type BrokerMeasurement = Message<"wavin.sentio.v1.BrokerMeasurement"> & {
  /**
   * Timestamp measured value
   *
   * @generated from field: google.protobuf.Timestamp timestamp = 1;
   */
  timestamp?: Timestamp;

  /**
   * Object ID of value
   *
   * @generated from field: uint32 oid = 2;
   */
  oid: number;

  /**
   * Value ID
   *
   * @generated from field: uint32 vid = 3;
   */
  vid: number;

  /**
   * Value valid
   *
   * @generated from field: bool valid = 4;
   */
  valid: boolean;

  /**
   * Value
   *
   * @generated from oneof wavin.sentio.v1.BrokerMeasurement.value
   */
  value: {
    /**
     * @generated from field: double numeric = 5;
     */
    value: number;
    case: "numeric";
  } | {
    /**
     * @generated from field: string text = 6;
     */
    value: string;
    case: "text";
  } | {
    /**
     * @generated from field: bytes data = 7;
     */
    value: Uint8Array;
    case: "data";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message wavin.sentio.v1.BrokerMeasurement.
 * Use `create(BrokerMeasurementSchema)` to create a new message.
 */
export const BrokerMeasurementSchema: GenMessage<BrokerMeasurement> = /*@__PURE__*/
  messageDesc(file_wavin_sentio_v1_broker_measurement, 0);

